/* assets/main.js — vanilla JS for BuzzPatch landing page */
(function () {
  "use strict";

  // ─── Smooth scroll for anchor links ──────────────────────────
  document.addEventListener("click", function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute("href");
    if (id === "#") {
      e.preventDefault();
      return;
    }
    var target = document.querySelector(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });

  // ─── Sticky CTA bar ──────────────────────────────────────────
  var stickyBar = document.querySelector(".bp-sticky-cta");
  if (stickyBar) {
    stickyBar.style.display = "none";
    var SHOW_AFTER = 300;
    var stickyVisible = false;
    window.addEventListener(
      "scroll",
      function () {
        var past = window.scrollY > SHOW_AFTER;
        if (past && !stickyVisible) {
          stickyBar.style.display = "";
          stickyVisible = true;
        } else if (!past && stickyVisible) {
          stickyBar.style.display = "none";
          stickyVisible = false;
        }
      },
      { passive: true },
    );
  }

  // ─── FAQ accordion ───────────────────────────────────────────
  var faqItems = document.querySelectorAll(".bp-faq-item");
  faqItems.forEach(function (item) {
    var header = item.querySelector(".bp-faq-header");
    var answer = item.querySelector(".bp-faq-a");
    var arrow = item.querySelector(".bp-faq-arrow");
    var plusArrow = item.querySelector(".bp-faq-arrow-ds.plus");
    var minusArrow = item.querySelector(".bp-faq-arrow-ds.minus");
    if (!header || !answer) return;


    // Initially collapse all answers
    answer.style.display = "none";

    header.addEventListener("click", function (e) {
      var isOpen = answer.style.display !== "none";
      var currentHeader = e.target;
        console.log(isOpen, "dddd")

      // Close all other open FAQs first
      faqItems.forEach(function (other) {
        var otherAnswer = other.querySelector(".bp-faq-a");
        var otherArrow = other.querySelector(".bp-faq-arrow");
        var otherHeader = other.querySelector(".bp-faq-header");
        var otherPlusArrow = other.querySelector(".bp-faq-arrow-ds.plus");
        var otherMinusArrow = other.querySelector(".bp-faq-arrow-ds.minus");
        if (otherAnswer && otherAnswer !== answer) {
          otherAnswer.style.display = "none";
          if (otherArrow) otherArrow.style.transform = "";
          // if (otherPlusArrow) otherPlusArrow.classList.add("active");
          // if (otherMinusArrow) otherMinusArrow.classList.remove("active");
          if(otherHeader) otherHeader.classList.remove("active");
        }
      });
      // Toggle current
      if (isOpen) {
        answer.style.display = "none";
        if (arrow) arrow.style.transform = "";
        // if (plusArrow) plusArrow.classList.add("active");
        // if (minusArrow) minusArrow.classList.remove("active");
        if(currentHeader) currentHeader.classList.remove("active");
      } else {
        answer.style.display = "block";
        if (arrow) arrow.style.transform = "rotate(180deg)";
        // if (plusArrow) plusArrow.classList.remove("active");
        // if (minusArrow) minusArrow.classList.add("active");
        if(currentHeader) currentHeader.classList.add("active");
      }
    });
  });

  // ─── Problem cards accordion (bp-problem-card) ───────────────
  var problemCards = document.querySelectorAll(".bp-problem-card");
  problemCards.forEach(function (card) {
    var header = card.querySelector(".bp-problem-header");
    var answer = card.querySelector(".bp-problem-a");
    var arrow = card.querySelector(".bp-problem-arrow");
    if (!header || !answer) return;

    answer.style.display = "none";

    header.addEventListener("click", function () {
      var isOpen = card.classList.contains("open");

      // Close all
      problemCards.forEach(function (other) {
        other.classList.remove("open");
        var otherA = other.querySelector(".bp-problem-a");
        var otherArrow = other.querySelector(".bp-problem-arrow");
        if (otherA) otherA.style.display = "none";
        if (otherArrow) otherArrow.style.transform = "";
      });

      // Toggle current
      if (!isOpen) {
        card.classList.add("open");
        answer.style.display = "block";
        if (arrow) arrow.style.transform = "rotate(180deg)";
      }
    });
  });

  // ─── Review carousel ─────────────────────────────────────────
  var track = document.querySelector(".bp-review-track");
  var dots = document.querySelectorAll(".bp-dot");
  var slides = track ? track.querySelectorAll(".bp-review-slide") : [];
  var current = 0;

  function goToSlide(idx) {
    if (!track || slides.length === 0) return;
    current = (idx + slides.length) % slides.length;
    track.style.transform = "translateX(-" + current * 100 + "%)";
    dots.forEach(function (d, i) {
      d.classList.toggle("active", i === current);
    });
  }

  dots.forEach(function (dot, i) {
    dot.addEventListener("click", function () {
      goToSlide(i);
    });
  });

  // Auto-advance every 5 s
  if (slides.length > 1) {
    setInterval(function () {
      goToSlide(current + 1);
    }, 5000);
  }

  // ─── Quantity selector ───────────────────────────────────────
  document.querySelectorAll(".bp-qty-controls").forEach(function (ctrl) {
    var valEl = ctrl.querySelector(".bp-qty-val");
    var minusBtn = ctrl.querySelector(".bp-qty-btn:first-child");
    var plusBtn = ctrl.querySelector(".bp-qty-btn:last-child");
    if (!valEl) return;

    function getQty() {
      return parseInt(valEl.textContent, 10) || 1;
    }

    if (minusBtn) {
      minusBtn.addEventListener("click", function () {
        var q = getQty();
        if (q > 1) valEl.textContent = q - 1;
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener("click", function () {
        valEl.textContent = getQty() + 1;
      });
    }
  });

  // ─── Pack card selection ─────────────────────────────────────
  document.querySelectorAll(".bp-pack-card").forEach(function (card) {
    card.addEventListener("click", function () {
      document.querySelectorAll(".bp-pack-card").forEach(function (c) {
        c.classList.remove("active");
      });
      card.classList.add("active");
    });
  });

  // ─── Subscribe option selection ──────────────────────────────
  document.querySelectorAll(".bp-subscribe-option").forEach(function (opt) {
    opt.addEventListener("click", function () {
      document.querySelectorAll(".bp-subscribe-option").forEach(function (o) {
        o.classList.remove("selected");
      });
      opt.classList.add("selected");
    });
  });

  // ─── Countdown timer ─────────────────────────────────────────
  var clocks = document.querySelectorAll(".bp-countdown-clock, .marty-countdown-timer");
  if (clocks.length > 0) {
    var endTime = Date.now() + (23 * 60 + 47) * 60 * 1000; // 23h 47m from page load
    function updateCountdown() {
      var remaining = Math.max(0, endTime - Date.now());
      var h = Math.floor(remaining / 3600000);
      var m = Math.floor((remaining % 3600000) / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      var formatted =
        String(h).padStart(2, "0") +
        ":" +
        String(m).padStart(2, "0") +
        ":" +
        String(s).padStart(2, "0");
      clocks.forEach(function (c) {
        c.textContent = formatted;
      });
    }
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }
})();
